import Swiper from 'swiper/bundle';

const buildSwiperSlider = sliderElm => {
    const sliderIdentifier = sliderElm.dataset.id;
    return new Swiper(`#${sliderElm.id}`, {
        spaceBetween: 20,
        slidesPerView: 1,
        loop: false,
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 16,
            },
        },
    });
}

const allSliders = $('.gallery-slider');

allSliders.each((index, element) => buildSwiperSlider(element));